<template>
	<el-dialog  :visible.sync="showPopup" width="700px" :show-close="false" @close = "close">
		<div class="dialog_top">
			<div class="dialog_userinfo">
				<div class="user_info_avatar">
					<img :src="user.avatar" alt="">
				</div>
				<div class="user_info_name_intro">
					<div class="user_info_name">{{user.nickname}}</div>
					<div class="user_name_intro" v-if="vipInfo.status === 1">会员有效期至：{{ vipInfo.end_time }}</div>
					<div class="user_name_intro" v-if="vipInfo.status !== 1">您当前未开通一席会员</div>
				</div>
			</div>
			<div class="dialog_btn" @click="go_vipDetail()">了解会员特权</div>
		</div>
		<div class="dialog_content">
			<div class="dialog_content_vip">
				<div class="vip_goods">
					<div class="vip_goods_item" 
					:class="{'select_goods_item':(select_index == i)}"
					@click="choose_item(i,item)" v-for="(item,i) in vip_goods_list" :key="i">
						<div class="vip_goods_item_name">{{item.name}}</div>
						<div class="vip_goods_item_price">
							<div class="fuhao_price">
								<span class="fuhao">¥</span>
								<div class="price">{{item.price}}</div>
								<span class="year">/年</span>
							</div>
						</div>
						<div class="vip_goods_item_tagname" v-if="item.tab">{{item.tab}}</div>
					</div>
				</div>
				<div class="pay_content">
					<div class="pay_price">
						<div class="pay_txt">需支付</div>
						<div class="pay_payprice">¥{{show_price}}</div>
					</div>
					<div class="wx_pay" v-show="pay_type !== 1 && pay_type !== 2" @click="wx_pay()">
						<i class="iconfont logo iconwxpay" style="color: #53c51a"></i>
						微信支付</div>
					<div class="zfb_pay" @click="zfb_pay()">
						<i class="iconfont logo iconalipay" style="color: #0679fe"></i>
						支付宝支付</div>		
				</div>
			</div>
			<div class="dialog_content_vip_tips">
				<div class="choose_item_tips">{{show_notice}}</div>
				<div class="vip_rules">确定支付即代表同意
					<span class="rule_link" @click="openAgreement('memberHandbook')">《会员服务协议》</span>
					<span class="rule_link" @click="openAgreement('continuityvip')" v-show="pay_type !== 3 && pay_type !== 4 && pay_type !== 5" >《自动续费服务规则》</span>
				</div>
			</div>
		</div>
		<el-dialog
		  width="260px"
		  custom-class="class1"
		  :visible.sync="wexinQRCodePopup"
		  append-to-body>
			<!-- 微信二维码支付弹框 -->
			<div class="weixin_qrcode-popup" v-show="wexinQRCodePopup">
			  <transition name="el-zoom-in-bottom">
				<div class="popup-container" v-show="wexinQRCodePopup">
				  <div class="qrcode-bl">
					<img :src="wexinQRCodeUrl" />
				  </div>
				  <div class="qrcode-tips" v-if="pay_type !== 1 && pay_type !== 2">使用微信扫码支付</div>
				  <div class="qrcode-tips" v-else>使用支付宝扫码支付并签约</div>
				  <div class="qrcode-btns">
					<div class="qrcode-btns_close" @click="close_qrcode()">关闭</div>
					<div class="qrcode-btns_chexe" @click="chexe_order()">手动查询</div>
				  </div>
				</div>
			  </transition>
			</div>
		</el-dialog>
		<el-dialog
			width="522px"
			:visible.sync="orderinfoshow"
			class="order_res-dialog" :show-close="false" center @close = "close_orderinf"
			append-to-body>
			<div class="order_res_info">
				<div class="order_res_info_title">
					<div v-if="order_status == 1"><img :src="require(`../assets/imgs/icon/pay_fail.png`)" />等待支付</div>
					<div v-else><img :src="require(`../assets/imgs/icon/pay_success.png`)" />支付成功</div>
				</div>
				<div class="order_res_info_tips">
					订单内容
				</div>
				<div class="order_res_info_info">
					<div class="order_info_item">
						<div class="info_item_left">订单编号</div>
						<div class="info_item_right">{{order_num}}</div>
					</div>
					<div class="order_info_item">
						<div class="info_item_left">订单金额</div>
						<div class="info_item_right">{{order_price}}元</div>
					</div>
					<div class="order_info_item">
						<div class="info_item_left">订单内容</div>
						<div class="info_item_right">
							<div v-if="pay_type == 1">一席会员(连续包季)</div>
							<div v-if="pay_type == 2">一席会员(连续包年)</div>
							<div v-if="pay_type == 3">一席会员(季度)</div>
							<div v-if="pay_type == 4">一席会员(年度)</div>
						</div>
					</div>
				</div>
				<div class="order_res_info_close">
					<div class="info_close_btn" @click="close_orderinf()">关闭</div>
				</div>
			</div>
		</el-dialog>
		<el-dialog
		width="522px"
		:visible.sync="continuityPopup"
		append-to-body
		>
			<div class="continuityContent">
				<div class="continuityTips">您已是连续包季/包年会员，无需重复购买</div>
				<div class="continuityBtn">
					<div class="continuityBtn_close" @click="colse_continuity()">关闭</div>
				</div>
			</div>
		</el-dialog>
	</el-dialog>
</template>

<script>
	import { mapState } from 'vuex';
	import requestApi from '@/service';
	import QRCode from 'qrcode';
	import { Dialog } from 'element-ui';
	export default {
		components: {
		  [Dialog.name]: Dialog,
		},
		computed: {
		  ...mapState(['vipInfo','vipType']),
		},
		props: {
		  payPopup: {
		    type: Boolean,
		    default: false,
		  },
		},
		data() {
			return {
				select_index:0,
				showPopup:false,
				wexinQRCodePopup:false,
				orderinfoshow:false,
				continuityPopup:false,
				wexinQRCodeUrl:'',
				user: {},
				vip_goods_list:[],
				show_price:'',
				show_notice:'',
				pay_type:1,//支付类型
				channel:'',//支付平台
				order_num:'',//订单编号
				order_price:'',//订单价格
				order_status:1,//订单状态
			}
		},
		watch: {
			payPopup(val) {
				this.showPopup = val
				if(this.showPopup == false) {
					this.$emit('close', false);
				}else {
					this.initUserInfo()
				}
			}
		},
		activated() {
			this.initUserInfo()
		},
		created() {
			this.get_vip_goods()
		},
		beforeDestroy() {
		  this.stopQueryOrderStatusTimer();
		},
		methods:{
			initUserInfo() {
			  this.user = this.$store.state.user || {};
			},
			close() {
				this.$emit('close', false);
			},
			close_qrcode() {
				this.wexinQRCodePopup = false;
			},
			colse_continuity() {
				this.continuityPopup = false;
			},
			close_orderinf() {
				this.orderinfoshow = false;
				if(this.order_status == 1){
					
				}else {
					this.orderTimer = setTimeout(() => {
						this.$router.go(0)
					},1000)
				}
			},
			//选择会员规格值
			choose_item(val,data) {
				this.select_index = val
				this.show_price = data.price
				this.show_notice = data.notice
				this.pay_type = data.buy_type
			},
			get_vip_goods() {
				requestApi('/v3/api/h5/member_join/').then(res => {
					this.vip_goods_list = res.item.price_info
					this.show_price = this.vip_goods_list[0].price
					this.show_notice = this.vip_goods_list[0].notice
					this.pay_type = this.vip_goods_list[0].buy_type
				})
			},
			wx_pay() {
				if(this.vipType == 1 || this.vipType == 2) {
					this.continuityPopup = true
					return
				}
				this.channel = 'wx_pc'
				requestApi('/v3/api/h5/order/wanxiang/',{
					channel:this.channel,
					order_type:0,
					buy_type:this.pay_type,
				},'POST').then(res => {
					this.showWeChatQRCode(res);
				})
			},
			showWeChatQRCode(res) {
				this.order_num = res.item.order_num
				this.order_price = res.item.total_fee
			  // 微信支付 显示二维码
			  const qrUrl = res.charge && res.charge.code_url;
			  if (qrUrl) {
			    // 二维码生成
			    QRCode.toDataURL(res.charge && res.charge.code_url, {
			      type: 'image/jpeg',
			      quality: 1,
			      margin: 1,
			    })
			      .then(url => {
			        this.wexinQRCodeUrl = url;
			        this.wexinQRCodePopup = true;
					this.startQueryOrderStatusTimer();
			      })
			      .catch(err => {
			        console.error('generate qrcode error =========> ', err);
			      });
			  } else {
			    console.error('no wechat qrcode =========> ');
			  }
			},
			zfb_pay() {
				this.channel = 'ali_pc'
				var redirect_url = window.location.href;
				if(this.vipType == 1 || this.vipType == 2) {
					this.continuityPopup = true
					return
				}
				if(this.pay_type == 1 || this.pay_type == 2) {
					var redirect_url = null
				}
				requestApi('/v3/api/h5/order/wanxiang/',{
					channel:this.channel,
					order_type:0,
					buy_type:this.pay_type,
					redirect_url,
				},'POST').then(res => {
					if(this.pay_type == 1 || this.pay_type == 2){
						res.charge.code_url = res.charge.return_url
						this.showWeChatQRCode(res);
					}else {
						window.location.href = res.charge.return_url
					}		
				})
			},
			/**
			 * @description: 若为微信或支付宝扫码支付 轮询支付结果
			 */
			startQueryOrderStatusTimer() {
			  if (this.queryOrderStatusTimer) {
			    this.stopQueryOrderStatusTimer();
			  }
			  this.queryOrderStatusTimer = setTimeout(() => {
			    this.queryOrderStatusTimer = null;
			    this.queryOrderStatus().then(msg => {
					if(msg == '等待支付') {
						this.startQueryOrderStatusTimer();
						this.order_status = 1
					}else {
						this.order_status = 2
						this.showPopup = false
						this.wexinQRCodePopup = false;
						this.orderinfoshow = true;
						
					}
				})
			  }, 2000);
			},
			/**
			 * @description: 停止微信支付轮询
			 */
			stopQueryOrderStatusTimer() {
			  clearTimeout(this.queryOrderStatusTimer);
			},
			/**
			 * @description: 点击手动查询
			 */
			chexe_order() {
				this.orderinfoshow = true;
				requestApi('/v3/api/h5/order/wanxiang/',
				{order_num:this.order_num,
				is_pc:1,
				buy_type:this.pay_type,},
				'GET').then(res => {
					if(res.msg == '等待支付') {
						
					}
					
					console.log(res)
				});
			},
			/**
			 * @description: 查询订单状态
			 */
			queryOrderStatus() {
				return new Promise(resolve => {
				  requestApi('/v3/api/h5/order/wanxiang/',
				  {order_num:this.order_num,
					is_pc:1,
					buy_type:this.pay_type,},
					'GET').then(
					({ msg }) => {
				    resolve(msg);
				  }
				  );
				});
			},
			
			//跳转到会员协议
			openAgreement(value) {
			  let path = `/about/${value}`;
			  const routeData = this.$router.resolve({
			    path,
			    query: {
			      type: 'more',
			    },
			  });
			  window.open(routeData.href, '_blank');
			},
			go_vipDetail() {
				const url = window.location.href
				if(url.indexOf('userCenter/vip_detail') != -1) {
					this.showPopup = false
				}else {
					// this.$router.push({
					//   path: 'userCenter',
					// });
					window.$router.replace({
						name: 'UserCentervip_detail',
					})
				}
				this.close()
			},	
		}
	}
</script>

<style lang="scss">
.el-dialog__header {
	display: none !important;
	padding: 0 !important;
}
.el-dialog__body {
	padding: 0 !important;
}
.class1 {
	border-radius: 10px;
}
.dialog_top {
	box-sizing: border-box;
	align-items: center;
	width: 100%;
	padding: 30px 20px 21px 52px;
	display: flex;
	justify-content: space-between;
	
}
.dialog_userinfo {
	display: flex;
	.user_info_avatar {
		width: 50px;
		height: 50px;
		border-radius: 50%;
		overflow: hidden;
		margin-right: 15px;
		img {
			object-fit: cover;
			width: 100%;
			height: 100%;
		}
	}
	.user_info_name_intro {
		width: 200px;
		position: relative;
		.user_info_name {
			font-weight: 500;
			font-size: 20px;
			line-height: 28px;
			color: #333333;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space:nowrap;
		}
		.user_name_intro {
			font-weight: 500;
			font-size: 14px;
			line-height: 20px;
			color: #333333;
			position: absolute;
			bottom: 0;
		}
	}
}
.dialog_btn {
	cursor: pointer;
	width: 117px;
	height: 36px;
	border: 1px #777 solid;
	border-radius: 5px;
	display: flex;
	align-items: center;
	justify-content: space-around;
	box-sizing: border-box;
}
.dialog_content {
	box-sizing: border-box;
	margin: 0 25px;
	border-top: 1px solid #D2D2D2;
	padding: 18px 0 22px 0;
	.dialog_content_vip {
		display: flex;
		justify-content: space-between;
		.vip_goods {
			margin-left: 39px;
			padding:20px 0;
			// width: calc(100% - 242px);
			display: flex;
			.vip_goods_item {
				cursor: pointer;
				margin-right: 25px;
				box-sizing: border-box;
				width: 166px;
				height: 117px;
				border: 2px solid #ddd;
				border-radius: 5px;
				position: relative;
				.vip_goods_item_name {
					font-weight: 500;
					font-size: 15px;
					line-height: 20px;
					color: #333333;
					text-align: center;
					margin-top: 17px;
				}
				.vip_goods_item_price {
					margin-top: 2px;
					width: 100%;
					display: flex;
					justify-content: space-evenly;
					font-weight: 500;
					font-size: 28px;
					line-height: 39px;
					color: #DA3F34;
					.fuhao_price {
						display: flex;
						align-items: center;
					}
					.fuhao {
						font-size: 14px;
						margin-right: 1px;
					}
					.year {
						font-size: 14px;
						margin-left: 1px;
					}
				}
				.vip_goods_item_tag {
					position: absolute;
					top: -7px;
					right: -1px;
					width: 40px;
					height: 23px;
					color: #fff;
					font-size: 12px;
					background: #DA3F34;
					border-radius: 5px;
					text-align: center;
					line-height: 23px;
				}
				.vip_goods_item_tagname {
					font-weight: 500;
					font-size: 10px;
					line-height: 18px;
					color: #fff;
					background: #DA3F34;
					border-radius: 3px;
					text-align: center;
					margin: auto;
					max-width: 76px;
				}
			}
			.select_goods_item {
				background: rgba(218, 63, 52, 0.1);
				border: 2px solid #DA3F34;
			}
		}
		.pay_content {
			box-sizing: border-box;
			border-left: 1px solid #BDBDBD;
			width: 182px;
			
			.pay_price {
				margin-left: 39px;
				margin-top: 18px;
				font-weight: 500;
				font-size: 16px;
				line-height: 2px;
				display: flex;
				margin-bottom: 22px;
				padding-top: 20px;
				.pay_txt {
					color: #333333;
				}
				.pay_payprice {
					margin-left: 3px;
					color: #DA3F34;
					font-size: 24px;
				}
			}
			.wx_pay,.zfb_pay {
				padding-left: 8px;
				cursor: pointer;
				width: 115px;
				height: 36px;
				font-size: 16px;
				line-height: 36px;
				color: #333333;
				box-sizing: border-box;
				border: 1px solid #777777;
				margin: 0 auto;
			}
			.wx_pay{
				margin-bottom: 19px;
			}
		}
	}
	.dialog_content_vip_tips {
		margin-top: 9px;
		font-weight: 400;
		margin-left: 39px;
		font-size: 16px;
		line-height: 22px;
		color: #777777;
		.choose_item_tips {
			margin-bottom: 10px;
		}
		.rule_link {
			color:#4F73F8 ;
			cursor: pointer;
		}
	}
}
.weixin_qrcode-popup {
	width: 260px;
	height: 260px;
	border-radius: 10px;
	overflow: hidden;
	.popup-container {
		width: 100%;
		height: 100%;
		background: #fff;
		padding-top: 14px;
		box-sizing: border-box;
	}
	.qrcode-bl {
		width: 170px;
		height: 173px;
		margin: 0 auto;
		text-align: center;
		img {
			width: 294px;
		}
	}
	.qrcode-tips {
		text-align: center;
		font-weight: 400;
		font-size: 14px;
		line-height: 20px;
		color: #333333;
	}
	.qrcode-btns {
		margin-top: 6px;
		display: flex;
		justify-content: space-between;
		font-size: 14px;
		font-weight: 600;
		text-align: center;
		padding: 0 25px;
		.qrcode-btns_close {
			width: 70px;
			line-height: 23px;
			color: #FFFFFF;
			background: #000000;
		}
		.qrcode-btns_chexe {
			box-sizing: border-box;
			width: 70px;
			line-height: 23px;
			color: #333333;
			border: 1px solid #000000;
		}
	}
}
.order_res_info {
	padding-top: 28px;
	padding-bottom: 10px;
	.order_res_info_title {
		div {
			margin: 0 auto;
			width: 180px;
			display: flex;
			align-items: center;
		}
		img {
			font-size: 0;
			width: 28px;
			height: 28px;
			margin-right: 5px;
		}
		font-weight: 600;
		font-size: 34px;
		line-height: 48px;
		color: #333;
		text-align: center;
		margin-bottom: 6px;
	}
	.order_res_info_tips {
		margin-bottom: 6px;
		font-weight: 500;
		font-size: 20px;
		line-height: 28px;
		color: #333333;
	}
	.order_res_info_info {
		background: #F3F3F3;
		padding: 4px 24px 20px 18px;
		.order_info_item {
			display: flex;
			justify-content: space-between;
			font-weight: 500;
			font-size: 28px;
			line-height: 39px;
			padding-top: 20px;
			color: #333333;
		}
		
	}
	.order_res_info_close {
		display: flex;
		justify-content: space-around;
		margin-top: 9px;
		.info_close_btn {
			width: 92px;
			height: 38px;
			background: #000000;
			font-weight: 600;
			font-size: 20px;
			line-height: 38px;
			color: #FFFFFF;
			text-align: center;
		}
	}
}
.continuityContent {
	padding-top: 49px;
	padding-bottom: 25px;
	.continuityTips {
		text-align: center;
		font-weight: 400;
		font-size: 24px;
		line-height: 34px;
		color: #333333;
	}
	.continuityBtn {
		margin-top: 58px;
		display: flex;
		justify-content: center;
		.continuityBtn_close {
			text-align: center;
			width: 100px;
			height: 44px;
			line-height: 44px;
			background: #000000;
			font-weight: 600;
			font-size: 20px;
			color: #FFFFFF;
		}
	}
}

</style>